import { cartTotalStyles as styles } from "@iewc/Overrides/Widgets/Cart/CartTotal";

styles.twoButtonModal = {
    ...styles.twoButtonModal,
    messageText: {
        ...styles.twoButtonModal?.messageText,
        lineHeight: "24PX",
    },
};
